import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Физика. 8 класс",
        subject: "Электромагнитная индукция",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Предупреждение трудностей формирования у младших школьников текстовой деятельности при изучении произведений эпоса.",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Пчёлкина М.А.",
                grade: "научный сотрудник",
                subGrade: " ",
                imageSrc: "./images/author_1.png"
            },
            {
                author: "Никифоров Г.Г.",
                grade: "к.пед.н.",
                subGrade: " ",
                imageSrc: "./images/author_2.png"
            },
            {
                author: "Андреева Н.В.",
                grade: "почётный работник ОО РФ",
                subGrade: " ",
                imageSrc: "./images/author_3.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'> Согласно Федеральной образовательной программе основного общего образования, тема «Электромагнитная индукция» изучается в 8-м классе и завершает раздел «Электрические и\n" +
                                "магнитные явления». Такая последовательность изложения материала устраняет существовавший \n" +
                                "ранее разрыв между открытиями Эрстеда и Ампера с одной стороны, и Фарадея – с другой.</p>"
                        },
                        {
                            type: "block",
                            listLabel: "<p style='padding-left: 2.4rem;'>Это ставит перед учителем новые методические задачи:</p>",
                            unorderedList: [
                                "обеспечить целостное восприятие обучающимися серии великих экспериментальных открытий, которые привели к созданию электродинамики и теории электромагнитного поля;",
                                "создать условия для более глубокого понимания неразрывной связи электричества и магнетизма, осознание единства которых в 8 классе часто вызывает у обучающихся трудности, что приводит, в свою очередь, к затруднениям при изучении в 9-м классе темы «Электромагнитное поле и электромагнитные волны», а в 11&#8209;м – основ электродинамики;",
                                "сформировать у обучающихся представление об историческом этапе развития физики, связанном с великими экспериментами Эрстеда, Ампера, Фарадея, сформировать ценностное отношение к их научным поискам."
                            ]
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В настоящем методическом кейсе мы предлагаем решить эти задачи путём изучения и воспроизведения исторических экспериментов в ходе самостоятельного исследования обучающихся. Учитель сможет познакомиться с примером эффективного применения методики обучения физике с использованием «цикла научного познания» и опорой на самостоятельный эксперимент.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В кейсе будет продемонстрировано, как выстраивание урока в исторической хронологии создаёт условия для погружения в научную проблему, совместного поиска её решения и дальнейшего самостоятельного «переоткрывания» научного знания обучающимися.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В кейсе будет показано, как:</p>"
                        },
                        {
                            type: "block",
                            unorderedList: [
                                "сконструировать урок на основе изучения значимых исторических экспериментов (опыты Эрстеда, Ампера, Фарадея);",
                                "организовать самостоятельное исследование обучающихся с использованием цикла научного познания (может ли магнитное поле породить электрический ток);",
                                "провести экспериментальную проверку нескольких выдвинутых обучающимися гипотез (условия возникновения индукционного тока; способы получения индукционного тока);",
                                "организовать воспроизведение исторического эксперимента (опыт Фарадея);",
                                "углубить естественнонаучные представления обучающихся через изучение «научной лаборатории» великих физиков прошлого (взаимосвязь электричества и магнетизма)."
                            ]
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Сивухин Д. В. Общий курс физики: В 5-ти томах. – Том 3. Электричество. – Москва: Физматлит, 2019",
                "Калашников С. Г. Электричество. Учебное пособие. – Москва: Физматлит, 2008",
                "Наука. Величайшие теории: выпуск 19: Наука высокого напряжения. Фарадей. Электромагнитная индукция. / Пер. с исп. – Москва: Де Агостини, 2015",
                "Кабардин О. Ф. История физики и развитие представлений о мире: элективный курс: 10 – 11-й класс: учеб. пособие. – Москва: АСТ: Астрель: Транзиткнига, 2005",
                "Енохович А. С., под ред. Б. И. Спасского. Хрестоматия по физике: Учебное пособие для учащихся 8-10 кл. сред. шк.— 2-е изд., перераб. – Москва: Просвещение, 1987",
                "Дуков В. М. Исторические обзоры в курсе физики средней школы. – Москва: Просвещение, 1983"
            ],
            filesToDownload: [
                {link: "./files/additional_information.pdf", fileName: "В чем ценность открытия электромагнитной индукции для каждого"},
            ]
        }
    ],
};
